import React, { useEffect } from 'react';

import { NavigationButtons } from 'composables/HearingTest/components/NavigationButtons';
import { StepContainer } from 'composables/HearingTest/components/StepContainer';

import SoundWave from '../assets/soundwave.svg';
import { useHearingTest, useHearingTestTracking } from '../HearingTestContext';
import { translations } from '../translations/en';
import { TOTAL_STEPS } from '../types/HearingTestTypes';
import { HearingTestEventAction } from '../types/TrackingTypes';

interface EarIntroStepProps {
  ear: 'left' | 'right';
}

export const EarIntroStep: React.FC<EarIntroStepProps> = ({ ear }) => {
  const { goToStep, state } = useHearingTest();
  const { trackHearingTestEvent } = useHearingTestTracking();

  useEffect(() => {
    const label = ear === 'left' ? 'Left Ear Intro' : 'Right Ear Intro';
    trackHearingTestEvent(HearingTestEventAction.LoadPage, label);
  }, [ear, trackHearingTestEvent]);

  const handleNext = () => {
    goToStep(state.currentStep + 1);
  };

  const isLeftEar = ear === 'left';

  return (
    <StepContainer currentStep={state.currentStep} totalSteps={TOTAL_STEPS}>
      <div className="space-y-8 text-center">
        <h1 className="text-3xl font-bold">
          {isLeftEar ? translations.nowfortest : translations.rightearintro}
        </h1>
        <p className="text-xl text-gray-800">
          {isLeftEar ? translations.startleftear : translations.moveontorightear}
        </p>

        <div className="sound-wave">
          <SoundWave
            className="mx-auto"
            role="img"
            aria-label={translations.soundwaveillustration}
          />
        </div>

        <NavigationButtons onNext={handleNext} />
      </div>
    </StepContainer>
  );
};
